import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Button } from 'components/ui/button';
import Tooltip from 'components/tooltip';
import SendRepEmailModal from './send_rep_email_modal';

// NOTE: we shouldn't need to respond to the "sendRepEmailModal:pending" event because this component reloads from the
// server each time the user switches to the syndication tab.
export default function SendRepEmailButton({
  companyUsers,
  hasPendingChanges,
  partnerNames,
  previouslySent,
  sendEmailSyndicationPath
}) {
  const buttonText = 'Send Rep Email';
  const [showModal, setShowModal] = useState(false);
  const [buttonDisabled, setButtonDisabled] = useState(false);

  const activeButton = () => (
    <Button onClick={() => setShowModal(true)}>
      {buttonText}
    </Button>
  );

  const inactiveButton = () => (
    <Tooltip content="No pending changes to send" dark={true} placement="bottom">
      <Button disabled>
        {buttonText}
      </Button>
    </Tooltip>
  );

  return (
    <React.Fragment>
      {(hasPendingChanges && !buttonDisabled) ? activeButton() : inactiveButton()}

      <SendRepEmailModal
        afterSend={() => setButtonDisabled(true)}
        companyUsers={companyUsers}
        partnerNames={partnerNames}
        previouslySent={previouslySent}
        sendEmailSyndicationPath={sendEmailSyndicationPath}
        show={showModal}
        onHide={() => setShowModal(false)}
      />
    </React.Fragment>
  );
}

SendRepEmailButton.propTypes = {
  companyUsers: PropTypes.array.isRequired,
  hasPendingChanges: PropTypes.bool.isRequired,
  partnerNames: PropTypes.arrayOf(PropTypes.string).isRequired,
  previouslySent: PropTypes.bool.isRequired,
  sendEmailSyndicationPath: PropTypes.string.isRequired,
};
